var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-danger"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-6 text-center m-3 p-0"},[_c('h2',{staticClass:"h4"},[_vm._v(" "+_vm._s(_vm.error)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }